<template>
    <div>
        <div class="footer">
            <div class="content-container footer-main">
                <div class="mobile">
                    <img class="logo" :src="logo_img"/>
                    <ul>
                        <li><a href="/">首页</a></li>
                        <li><a href="/about">公司介绍</a></li>
                        <li><a href="/houseList/2">汉伦投资</a></li>
                    </ul>
                    <ul>
                        <li><a href="/management">汉伦物业管理</a></li>
                        <li><a href="/directRent">优质房源</a></li>
                        <li><a href="/contact">联系我们</a></li>
                    </ul>
                </div>
                <div>
                    <div class="us"><span class="line"></span>联系我们<span class="line"></span></div>
                    <div class="two-code">
                        <div class="code-name">
                            <img :src="code_img1" />
                            <div>汉伦投资</div>
                        </div>
                        <div class="code-name">
                            <img :src="code_img2" />
                            <div>汉伦管家</div>
                        </div>
                        <div class="code-name">                
                            <img :src="code_img3" />
                            <div>汉伦物业管理</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bei-an">
            <a href="http://beian.miit.gov.cn/" target="_black">京ICP备16045865号-1* 2021 北京汉伦管理咨询有限公司版权所有</a>
        </div>
    </div>
</template>
<script>

import logo_img from '@assets/image/index/logo-footer.jpg'
import code_img1 from '@assets/image/index/code_1.jpg'
import code_img2 from '@assets/image/index/code_2.jpg'
import code_img3 from '@assets/image/index/code_3.png'

export default {
    name:'FooterComponent',
    components:{
       
    },
    data() {
        return {
            logo_img,
            code_img1,code_img2,code_img3
        }
    }
}
</script>
<style lang="scss" scoped>
.footer{
    height: 20rem;
    width: 100%;
    padding-top:2.7rem;
    background: url('../assets/image/index/footer-bg.jpg') no-repeat center;
    background-size: cover;
}
.logo{
    width: 10rem;
    height: 5rem;
}
.footer-main{
    display: flex;
    justify-content: space-between;
}
li{
    a{
        font-size: 1.1rem;
        color: #fff; 
    }
    margin-bottom: 1.5rem;
}
.us{
	font-size: 1rem;
    color: #ffffff;
    text-align: center;
    .line{
        display: inline-block;
        width: 3rem;
        border: 1px solid #3a4a5b;
        margin:0 1.5rem 0.25rem;
    }
}
.two-code{
    margin-top:2rem;
    display: flex;
    font-size: 0.8rem;
    color: #fff;
    line-height: 2rem;
    img{
        width: 4.8rem;
        height: 4.8rem;
    }
}
.mobile{
    width: 30rem;
    display: flex;
    justify-content: space-between;
}
.code-name{
    margin-right: 2rem;
    text-align: center;
    font-size: 0.8rem;
}
.bei-an{
    text-align: center;
    font-family: MicrosoftYaHeiLight;
	font-size: 0.8rem;
	color: #ffffff;
    height: 3.2rem;
    line-height: 3.2rem;
    background: #3a4a5b;
    a{
        color: #fff;
    }
}
@media only screen and (max-width: 1024px){
    .footer{
        height: auto;
        padding-right: 2rem;
        padding-left: 2rem;
    }
    .footer-main{
        width: 100%;
        display: block;
    }
    li{
        margin-bottom:1rem;
    }
    .mobile{
        display: flex;
    }
    .two-code{
        display: flex;
        justify-content:space-around;
    }
    .bei-an{
        height: 2rem;
        line-height: 2rem;
        a{
            font-size: 0.6rem;
        }
    }
}
</style>